import { render, staticRenderFns } from "./paypal_button.vue?vue&type=template&id=2354c191&scoped=true&"
import script from "./paypal_button.vue?vue&type=script&lang=js&"
export * from "./paypal_button.vue?vue&type=script&lang=js&"
import style0 from "./paypal_button.vue?vue&type=style&index=0&id=2354c191&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354c191",
  null
  
)

export default component.exports